<template>
  <employee-list-h5 v-if="path === 1"/>
  <!-- 职员列表管理，企业微信端显示 -->
  <employee-list-q-w v-else-if="path === 2"/>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import EmployeeListH5 from "@/views/h5/common/basedata/employee/EmployeeListH5.vue";
import EmployeeListQW from "@/views/h5/common/basedata/employee/EmployeeListQW.vue";
import Util from "@/util/util";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  name: "EL",
  components: {
    EmployeeListH5, EmployeeListQW
  },
  data() {
    return {
      path: 0, // 运行环境
      systemName: process.env.VUE_APP_SYSTEM_CODE,
    };
  },
  async created() {
    this.path = Util.getContextPath();
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>

</style>